
import { useState, useEffect } from 'react';

export default function Home() {
  const [selectedService, setSelectedService] = useState(0);

  const services = [
    {
      title: 'キッチンリフォーム',
      description: '最新設備で快適なキッチン空間を実現',
      price: '50万円〜',
      image: 'https://public.readdy.ai/ai/img_res/56dd0704c4b94c64d6dcad71b9bfafa2.jpg'
    },
    {
      title: 'バスルームリフォーム',
      description: 'リラックスできる上質なバスタイム空間',
      price: '60万円〜',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20bathroom%20renovation%20with%20modern%20bathtub%2C%20glass%20shower%2C%20marble%20tiles%2C%20elegant%20lighting%2C%20spa-like%20atmosphere%2C%20professional%20interior%20photography%20style&width=600&height=400&seq=bathroom1&orientation=landscape'
    },
    {
      title: '各種設備機器の交換',
      description: '住まいの美観と耐久性を向上',
      price: '1万円〜',
      image: 'https://readdy.ai/api/search-image?query=House%20exterior%20renovation%20with%20new%20siding%2C%20modern%20roof%20tiles%2C%20fresh%20paint%2C%20beautiful%20landscaping%2C%20professional%20architectural%20photography%20style&width=600&height=400&seq=exterior1&orientation=landscape'
    }
  ];

  const workAreas = [
    '東京都', '神奈川県', '埼玉県', '千葉県', 'その他　お問い合わせください。'
  ];

  useEffect(() => {
    // Schema.org JSON-LD for LocalBusiness
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "有限会社アットコール",
      "description": "住宅リフォーム会社。キッチン、バスルーム、水道工事など20年の実績。関東圏対応、無料見積もり実施中。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "telephone": "090-9397-4969",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "芝富士1-22-31",
        "addressLocality": "川口市",
        "addressRegion": "埼玉県",
        "postalCode": "333-0854",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 35.8071,
        "longitude": 139.7243
      },
      "openingHours": "Mo-Su 09:00-18:00",
      "priceRange": "¥¥",
      "serviceArea": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": 35.8071,
          "longitude": 139.7243
        },
        "geoRadius": "50000"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "リフォームサービス",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "キッチンリフォーム",
              "description": "最新設備で快適なキッチン空間を実現"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "ユニットバスリフォーム",
              "description": "リラックスできる上質なバスタイム空間"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "水漏れ修理",
              "description": "緊急対応可能な水道工事サービス"
            }
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
                有限会社アットコール
              </h1>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                ホーム
              </a>
              <a href="#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                サービス
              </a>
              <a href="#about" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                会社概要
              </a>
              <a href="/contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                お問い合わせ
              </a>
            </nav>
            <button className="md:hidden">
              <i className="ri-menu-line text-2xl text-gray-700"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center bg-cover bg-center"
               style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('https://static.readdy.ai/image/c94c498328eac230fb4300ce52f93b0b/d253a80b47edff23c709a8d150209aa8.jpeg')` }}>
        <div className="text-center text-white max-w-4xl mx-auto px-4">
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            理想の住まいを<br />
            <span className="text-blue-400">実現します</span>
          </h2>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            20年の信頼と実績で、あなたの住まいに安心を
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://ssl.form-mailer.jp/fms/d50e6e00868611" className="bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
              無料見積もり依頼
            </a>
            <a href="#services" className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
              施工事例を見る
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">施工内容</h3>
            <p className="text-xl text-gray-600">豊富な経験と確かな技術で、あらゆるニーズにお応えします</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {services.map((service, index) => (
              <div key={index}
                   className={`bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transition-transform hover:scale-105 ${selectedService === index ? 'ring-4 ring-blue-500' : ''}`}
                   onClick={() => setSelectedService(index)}>
                <img src={service.image} alt={service.title} className="w-full h-48 object-cover object-top" />
                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h4>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <div className="flex justify-between items-center">
                    <span className="text-2xl font-bold text-blue-600">{service.price}</span>
                    <i className="ri-arrow-right-line text-blue-600 text-xl"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-4-line text-2xl text-blue-600"></i>
              </div>
              <h5 className="font-bold text-gray-900 mb-2">内装工事</h5>
              <p className="text-gray-600 text-sm">壁紙・床材・天井工事</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hammer-line text-2xl text-green-600"></i>
              </div>
              <h5 className="font-bold text-gray-900 mb-2">水回り工事</h5>
              <p className="text-gray-600 text-sm">キッチン・浴室・トイレ</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-2xl text-orange-600"></i>
              </div>
              <h5 className="font-bold text-gray-900 mb-2">外装工事</h5>
              <p className="text-gray-600 text-sm">外壁・屋根・エクステリア</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-2xl text-purple-600"></i>
              </div>
              <h5 className="font-bold text-gray-900 mb-2">設備工事</h5>
              <p className="text-gray-600 text-sm">電気・ガス・給排水</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">料金プラン</h3>
            <p className="text-xl text-gray-600">明確で分かりやすい料金体系</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h4 className="text-2xl font-bold text-gray-900 mb-4">ライトプラン</h4>
              <div className="text-4xl font-bold text-blue-600 mb-6">30万円〜</div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-5 00 mr-3"></i>
                  <span>部分的なリフォーム</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>壁紙・床材交換</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>基本保証1年</span>
                </li>
              </ul>
              <button className="w-full bg-gray-200 text-gray-800 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-colors whitespace-nowrap">
                詳細を見る
              </button>
            </div>

            <div className="bg-blue-600 p-8 rounded-lg text-white relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-orange-500 text-white px-4 py-1 rounded-full text-sm font-semibold">
                人気No.1
              </div>
              <h4 className="text-2xl font-bold mb-4">スタンダードプラン</h4>
              <div className="text-4xl font-bold mb-6">80万円〜</div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-400 mr-3"></i>
                  <span>水回り全面リフォーム</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-400 mr-3"></i>
                  <span>設備機器交換</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-400 mr-3"></i>
                  <span>保証3年</span>
                </li>
              </ul>
              <button className="w-full bg-white text-blue-600 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap">
                詳細を見る
              </button>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h4 className="text-2xl font-bold text-gray-900 mb-4">プレミアムプラン</h4>
              <div className="text-4xl font-bold text-blue-600 mb-6">150万円〜</div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>全面リノベーション</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>設計から施工まで</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>保証5年</span>
                </li>
              </ul>
              <button className="w-full bg-gray-200 text-gray-800 py-3 rounded-lg font-semibold hover:bg-gray-3�30 transition-colors whitespace-nowrap">
                詳細を見る
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Work Areas Section */}
      <section id="areas" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">対応エリア</h3>
            <p className="text-xl text-gray-600">首都圏を中心に柔軟に対応</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="grid grid-cols-1 gap-4">
                {workAreas.map((area, index) => (
                  <div key={index} className="bg-white p-4 rounded-lg shadow-md flex items-center">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-map-pin-line text-blue-600 text-xl"></i>
                    </div>
                    <span className="text-lg font-semibold text-gray-900">{area}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/c94c498328eac230fb4300ce52f93b0b/cd24b52e93e6f73a8ef6c62548797a90.png"
                alt="関東地区施工エリアマップ"
                className="w-full rounded-lg shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Access Section */}
      <section id="access" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">アクセス</h3>
            <p className="text-xl text-gray-600">お気軽にお越しください</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <div className="bg-gray-50 p-8 rounded-lg">
                <h4 className="text-2xl font-bold text-gray-900 mb-6">会社情報</h4>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <i className="ri-building-line text-blue-600"></i>
                    </div>
                    <div>
                      <strong>有限会社アットコール</strong><br />
                      333-0854<br />
                      埼玉県川口市芝富士1-22-31<br />
                      　
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-phone-line text-green-600"></i>
                    </div>
                    <span>090-9397-4969</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-time-line text-orange-600"></i>
                    </div>
                    <span>営業時間：9:00〜18:00</span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.0977842052!2d139.70245!3d35.6702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDQwJzEyLjciTiAxMznCsDQyJzA4LjgiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
                width="100%"
                height="400"
                style={{ border: 0, borderRadius: '8px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="会社所在地"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-4xl font-bold mb-4">お問い合わせ</h3>
          <p className="text-xl mb-8 opacity-90">
            無料見積もり・ご相談はお気軽にどうぞ
          </p>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white text-blue-600 p-6 rounded-lg">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-bold mb-4">お電話でのお問い合わせ</h4>
              <div className="space-y-2">
                <a href="tel:0120-8656-24" className="block text-2xl font-bold hover:text-blue-800 transition-colors cursor-pointer">
                  0120-8656-24
                </a>
                <a href="tel:090-9397-4969" className="block text-2xl font-bold hover:text-blue-800 transition-colors cursor-pointer">
                  090-9397-4969
                </a>
              </div>
              <p className="text-sm text-gray-600 mt-4">営業時間：9:00〜18:00</p>
            </div>
            <div className="bg-white text-blue-600 p-6 rounded-lg">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <a href="https://ssl.form-mailer.jp/fms/d50e6e00868611" className="cursor-pointer">
                  <i className="ri-mail-line text-2xl text-blue-600"></i>
                </a>
              </div>
              <h4 className="text-xl font-bold mb-4">メールでのお問い合わせ</h4>
              <a href="https://ssl.form-mailer.jp/fms/d50e6e00868611" className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                メール送信
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                有限会社アットコール
              </h4>
              <p className="text-gray-400">
                お客様の理想の住まいづくりをサポートする、信頼のリフォーム会社です。
              </p>
            </div>
            <div>
              <h5 className="font-bold mb-4">サービス</h5>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">キッチンリフォーム</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">バスルームリフォーム</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">外壁・屋根工事</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">内装工事</a></li>
              </ul>
            </div>
            <div>
              <h5 className="font-bold mb-4">会社情報</h5>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">会社概要</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">施工事例</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">お客様の声</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">採用情報</a></li>
              </ul>
            </div>
            <div>
              <h5 className="font-bold mb-4">お問い合わせ</h5>
              <div className="space-y-2 text-gray-400">
                <p>〒333-0854<br />埼玉県川口市芝富士1-22-31</p>
                <p>TEL: 090-9397-4969</p>
                <p>営業時間: 9:00〜18:00</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 有限会社アットコール. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
